import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles, TextAreaExtraProps } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const SendToDebtCollectionForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  return (
    <GenericForm<InvoiceFormTypes.SendToDebtCollection>
      formRef={ref}
      {...props}
      fields={{
        note: {
          label: "",
          type: FormEnums.FormFieldType.TEXTAREA,
          placeholder: TranslationKeys.Invoice.SendToDebtCollectionDialogPlaceholder,
          descriptionText: TranslationKeys.Invoice.SendToDebtCollectionDialogDescription,
          maxLength: 120,
          extraProps: {
            rows: 2,
          } as TextAreaExtraProps,
        },
      }}
    />
  );
};

export default forwardRef(SendToDebtCollectionForm);
